import { getUsecases } from './usecase.service'
import { alliance, entity_types, area_types } from '../config/constant'
import { Usecase } from 'src/redux/reducers/types'

export async function processUsecaseFromForm(form_data: any) {
    let usecase: Usecase = {
        id: 0,
        name: '',
        entities: [],
        areas: [],
        maxDuration: 0,
        environmentConfigId: 0,
    }

    // ID Processing

    let ids_from_db = [0]

    try {
        const result = await getUsecases()

        if (result.data.usecases.length > 0) {
            result.data.usecases.map((item: any) => {
                ids_from_db.push(parseInt(item.id))
            })
        } else {
            ids_from_db.push(0)
        }
    } catch (e) {
        return { error: true, data: 'Error looking for usecase id, check if API-Usecase is running!' }
    }

    // @ts-ignore 2025-05-23 Note ST - Overriding/creating a new method for arrays...?
    Array.prototype.max = function () {
        return Math.max.apply(null, this)
    }

    if (ids_from_db.length > 0) {
        // @ts-ignore 2025-05-23 Note ST - Should be OK after the above `.max()` definition
        usecase.id = ids_from_db.max() + 1
    } else {
        usecase.id = 1
    }

    // NAME Processing

    usecase.name = form_data.name

    // MAX DURATION Processing

    usecase.maxDuration = parseInt(form_data.max_duration)

    // ENVIRONMENT CONFIGURATION ID Processing
    usecase.environmentConfigId = parseInt(form_data.environment_config_id)

    // AREAS Processing

    let main_area = {
        id: '1',
        name: form_data.main_area_name,
        type: area_types.neutral,
        coordinates: {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [parseFloat(form_data.main_area_lon), parseFloat(form_data.main_area_lat)],
            },
        },
        validity: true,
    }

    usecase.areas.push(main_area)

    for (let index = 0; index < form_data.areas.length; ++index) {
        const area = form_data.areas[index]

        let polygon_array = []

        for (let index_areas = 0; index_areas < area.polygon.length; ++index_areas) {
            const coordinate = area.polygon[index_areas]
            let array_coordinate = [parseFloat(coordinate['lon']), parseFloat(coordinate['lat'])]
            polygon_array.push(array_coordinate)
        }

        // Close polygon if the user didn´t
        if (polygon_array[0] != polygon_array[polygon_array.length - 1]) {
            polygon_array.push(polygon_array[0])
        }

        let new_area = {
            id: (index + 2).toString(),
            name: area.name,
            type: area.type,
            coordinates: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [polygon_array],
                },
            },
            validity: false,
        }

        usecase.areas.push(new_area)
    }

    // ENTITIES Processing

    for (let index = 0; index < form_data.payload_assets.length; ++index) {
        const entity = form_data.payload_assets[index]

        const payload_waypoint = []

        if (entity.position['lat'] != '' && entity.position['lon'] != '') {
            const payload_position = {
                latitude: parseFloat(entity.position['lat']),
                longitude: parseFloat(entity.position['lon']),
                altitude: entity.position['alt'] ? parseFloat(entity.position['alt']) : 0,
                velocity: 0,
            }

            payload_waypoint.push(payload_position)
        }

        // Orient Look and zoom actions
        let payload_actions = {
            DoOrientSensor: entity.actions_orient,
            DoLookAt: entity.actions_look,
            DoZoom: entity.actions_zoom,
            GetDetection: entity.actions_get_detection,
        }

        for (const [key, value] of Object.entries(payload_actions)) {
            if (value.length == 0) {
                // @ts-ignore 2025-05-23 Probably OK
                delete payload_actions[key]
            }
        }

        let new_entity = {
            id: 'payload_' + index.toString(),
            name: entity.name,
            type: entity.type,
            model: entity.model,
            waypoints: payload_waypoint,
            alliance: alliance.friendly,
            payloads: [],
            actionsEnvironments: payload_actions,
        }

        if (Object.keys(payload_actions).length == 0) {
            // @ts-ignore 2025-05-23 Probably OK
            delete new_entity['actionsEnvironments']
        }

        usecase.entities.push(new_entity)
    }

    for (let index = 0; index < form_data.platform_assets.length; ++index) {
        const entity = form_data.platform_assets[index]

        const payloads_array = []

        if (usecase.entities.length > 0) {
            for (let payload_checked = 0; payload_checked < entity.payload.length; ++payload_checked) {
                for (let payload_index = 0; payload_index < usecase.entities.length; ++payload_index)
                    if (payload_checked == payload_index && entity.payload[payload_checked]) {
                        payloads_array.push(usecase.entities[payload_checked].id)
                    }
            }
        }

        let sparqId = entity.sparq_id
        if (entity.sparq_id === '' || entity.sparq_id == null) {
            if (entity.type === entity_types.gcs) {
                sparqId = 'Default'
            }
        }

        // Goto and Neutralization actions
        let platform_actions = {
            DoGoto: entity.actions_goto,
            DoTriggerNeutralization: entity.actions_neutralization,
            GetTelemetry: entity.actions_get_telemetry,
        }

        for (const [key, value] of Object.entries(platform_actions)) {
            if (value.length == 0) {
                // @ts-ignore 2025-05-23 Probably OK
                delete platform_actions[key]
            }
        }

        let new_entity = {
            id: 'platform_' + index.toString(),
            name: entity.name,
            type: entity.type,
            model: entity.model,
            waypoints: [
                {
                    latitude: parseFloat(entity.position['lat']),
                    longitude: parseFloat(entity.position['lon']),
                    altitude: parseFloat(entity.position['alt']),
                    velocity: 0,
                },
            ],
            alliance: alliance.friendly,
            payloads: payloads_array,
            actionsEnvironments: platform_actions,
            sparqId: undefined,
            squadId: undefined,
        }

        if (sparqId) {
            new_entity.sparqId = sparqId
        }

        if (entity.squad_id) {
            new_entity.squadId = entity.squad_id
        }

        if (Object.keys(platform_actions).length == 0) {
            // @ts-ignore 2025-05-23 Probably OK
            delete new_entity['actionsEnvironments']
        }

        usecase.entities.push(new_entity)
    }

    for (let index = 0; index < form_data.threats.length; ++index) {
        const entity = form_data.threats[index]

        let waypoints_array = []

        let initial_array_coordinate = {
            latitude: parseFloat(entity.initial_position['lat']),
            longitude: parseFloat(entity.initial_position['lon']),
            altitude: parseFloat(entity.initial_position['alt']),
            velocity: 0.0,
        }
        waypoints_array.push(initial_array_coordinate)

        for (let index_waypoints = 0; index_waypoints < entity.waypoints.length; ++index_waypoints) {
            const coordinate = entity.waypoints[index_waypoints]

            let array_coordinate = {
                latitude: parseFloat(coordinate.lat),
                longitude: parseFloat(coordinate.lon),
                altitude: parseFloat(coordinate.alt),
                velocity: parseFloat(coordinate.vel),
            }
            waypoints_array.push(array_coordinate)
        }

        // Goto actions
        let threat_actions = {
            DoGoto: entity.actions_goto,
            GetTelemetry: entity.actions_get_telemetry,
        }

        for (const [key, value] of Object.entries(threat_actions)) {
            if (value.length == 0) {
                // @ts-ignore 2025-05-23 Probably OK
                delete threat_actions[key]
            }
        }

        let new_entity = {
            id: 'threat_' + index.toString(),
            name: entity.name,
            type: entity.type,
            model: entity.model,
            waypoints: waypoints_array,
            alliance: entity.alliance,
            payloads: [],
            actionsEnvironments: threat_actions,
            sparqId: undefined,
            squadId: undefined,
        }

        if (entity.sparq_id) {
            new_entity.sparqId = entity.sparq_id
        }

        if (entity.squad_id) {
            new_entity.squadId = entity.squad_id
        }

        if (Object.keys(threat_actions).length === 0) {
            // @ts-ignore 2025-05-23 Probably OK
            delete new_entity['actionsEnvironments']
        }

        usecase.entities.push(new_entity)
    }

    console.info('Preprocessed usecase:', usecase)

    return { error: false, data: usecase }
}
